import { AppProvider } from "contexts";
import { UnsubscribeFinished } from "pages/unsubscribe/finished";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Home, Unsubscribe, Authorization } from '../pages/index'


export default function WishListRoutes() {
    return (
        <Router>
            <Switch>
                <AppProvider>
                    <Route exact path="/">
                        <Home />
                    </Route>
                    <Route exact path="/unsubscribe">
                        <Unsubscribe />
                    </Route>
                    <Route exact path="/unsubscribe/finished">
                        <UnsubscribeFinished />
                    </Route>
                    <Route path="/authorization">
                        <Authorization />
                    </Route>
                </AppProvider>
            </Switch>
        </Router>
    )
}
